import React from 'react'
import PropTypes from 'prop-types'
import logout from '../assets/images/logout.gif'

/**
 * Logout component handles user logout process and displays a confirmation message.
 * It clears session-related data from localStorage and redirects to the logout URL.
 *
 * @module common/Logout
 * @description Handles user logout and displays a confirmation message.
 *
 * @component
 * @example
 * return <Logout isLocalEnvironment="http://localhost:3000" />;
 *
 * @param {Object} props - The component props.
 * @param {string} props.isLocalEnvironment - Base URL for local environment logout.
 *
 * @returns {React.Element} Renders the logout confirmation page.
 */
export const Logout = ({ isLocalEnvironment }) => {
  React.useEffect(() => {
    const redirectURL = window.location.origin
    sessionStorage.removeItem('authenticateSession')
    sessionStorage.removeItem('auth')
    sessionStorage.removeItem('loggedIn')
    sessionStorage.removeItem('builderAssets')
    sessionStorage.removeItem('defApp')
    sessionStorage.removeItem('activeRoutes')
    sessionStorage.removeItem('mainMenu')

    window.open(`${isLocalEnvironment}/auth/logout?url=${redirectURL}`, '_self')
  }, [isLocalEnvironment]) // Run only once when the component mounts

  return (
    <div className="trtui-auth-page-wrapper trtui-auth-bg-cover trtui-py-5 trtui-d-flex trtui-justify-content-center trtui-align-items-center trtui-min-vh-100">
      <div className="trtui-bg-overlay" />
      <div className="trtui-auth-page-content trtui-overflow-hidden trtui-pt-lg-5">
        <div className="trtui-container">
          <div className="trtui-row">
            <div className="trtui-col-lg-12">
              <div className="trtui-card trtui-overflow-hidden">
                <div className="trtui-row trtui-justify-content-center trtui-g-0">
                  <div className="trtui-col-lg-6">
                    <div className="trtui-p-lg-5 trtui-p-4 trtui-text-center">
                      <img src={logout} alt="Logout" />
                      <div className="trtui-mt-4 trtui-pt-2">
                        <h5>Logged Out</h5>
                        <p className="trtui-text-muted">You have been successfully logged out.</p>
                        <div className="trtui-mt-4">
                          <a href="/" className="trtui-btn trtui-btn-secondary trtui-w-100">
                            Go To Home Page
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer className="trtui-footer">
        <div className="trtui-container">
          <div className="trtui-row">
            <div className="trtui-col-lg-12">
              <div className="trtui-text-center">
                <p className="trtui-mb-0">
                  © TRT. Developed by <strong>Thulisha Reddy Technologies</strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}

Logout.propTypes = {
  /**
   * Base URL for local environment logout.
   */
  isLocalEnvironment: PropTypes.string.isRequired,
}
